/**
 * Creates an object map where keys are field names and values are field objects
 * Useful for quick field lookup by name without iterating through the array
 * @param {Array<Object>} fields - Array of field objects with name property
 * @returns {Object} Object where keys are field names and values are field objects
 * @example
 * const fields = [
 *   { name: 'time_node', type: '24_hours_time_array', value: [...] },
 *   { name: 'date_node', type: 'date', value: '2025-11-14' },
 *   { name: 'status', type: 'boolean', value: true }
 * ];
 * getFieldsByName(fields)
 * // returns {
 * //   time_node: { name: 'time_node', type: '24_hours_time_array', value: [...] },
 * //   date_node: { name: 'date_node', type: 'date', value: '2025-11-14' },
 * //   status: { name: 'status', type: 'boolean', value: true }
 * // }
 *
 * @example
 * getFieldsByName([]) // returns {}
 * getFieldsByName(null) // returns undefined
 */
export const getFieldsByName = (fields) =>
    fields?.reduce((fieldsByName, field) => {
        fieldsByName[field.name] = field;

        return fieldsByName;
    }, {});
